import React, { Component } from 'react';
import { Tab, Tabs } from 'material-ui/Tabs';
import EVVReadyToBill from './EVVReadyToBill';
import EVVSubmittedClaim from './EVVSubmittedClaim';
import EVVProccessedClaim from './EVVProccessedClaim';
import EVVApprovedClaims from './EVVApprovedClaims';
// import ClaimHistory from './ClaimHistory';
import FontIcon from 'material-ui/FontIcon';

class ManageClaims extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 0,
      activeTabValue: '0',
      slideIndex: null,
      claimHistoryId: null,
    };
    this.handleClaimIdTabChange = this.handleClaimIdTabChange.bind(this);

  }

    state = {
      open: false,
    };
    handleOpen = () => {
      this.setState({ open: true });
    };
    handleClose = () => {
      this.setState({ open: false });
    };

    setActive(tabValue) {
      if (tabValue === this.state.activeTab) {
        return false;
      }
      this.setState({ activeTab: tabValue });
    }

    handleClaimTabChange = (value) => { //  Change Tab on form Submit.

      this.setState({ activeTabValue: value, activeTab: parseInt((value || 0), 10), claimHistoryId: null });
    };

    handleClaimIdTabChange(value, claimId) {
      // console.log('claimId...........................',claimId);
      this.setState({ activeTabValue: value, activeTab: parseInt((value || 0), 10) });
      this.setState({ claimHistoryId: claimId });
    };


    render() {
      var styles = {
        default_tab: {
          height: '50px',
          fontSize: '13px',
        },
        active_tab: {
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.10)',
          height: '48px',
          fontSize: '13px',
        },
      };
      styles.tab = [];
      styles.tab[0] = styles.default_tab;
      styles.tab[1] = styles.default_tab;
      styles.tab[2] = styles.default_tab;
      styles.tab[3] = styles.default_tab;      
      styles.tab[this.state.activeTab] = styles.active_tab;
      styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);

      return (
        <div>
          <h2 className="page_title">Manage EVV</h2>
          <Tabs className="custom_tabs" value={this.state.activeTabValue} onChange={this.handleClaimTabChange}>
            <Tab
              onClick={(e) => this.setActive(0)}
              style={styles.tab[0]}
              value="0"
              className="customtab"
              icon={<FontIcon className="material-icons">filter_1</FontIcon>}
              label={<font>Ready To Submit</font>}>
              <div className="readmin-panel">
                {this.state.activeTab === 0 ?
                  <EVVReadyToBill location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} handleClaimIdTabChange= {this.handleClaimIdTabChange}/>
                  : null}
              </div>
            </Tab>
            <Tab
              onClick={(e) => this.setActive(1)}
              style={styles.tab[1]}
              value="1"
              className="customtab"
              icon={<FontIcon className="material-icons">filter_2</FontIcon>}
              label={<font>Submitted</font>}>
              <div className="readmin-panel">

                {this.state.activeTab === 1 ?
                  <EVVSubmittedClaim location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} handleClaimIdTabChange= {this.handleClaimIdTabChange}/>
                  : null}

              </div>
            </Tab>
            <Tab
              onClick={(e) => this.setActive(2)}
              style={styles.tab[2]}
              value="2"
              className="customtab"
              icon={<FontIcon className="material-icons">filter_3</FontIcon>}
              label={<font>Rejected</font>}>
              <div className="readmin-panel">
                {this.state.activeTab === 2 ?
                  <EVVProccessedClaim location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} />
                  : null}
              </div>
            </Tab>
            <Tab
              onClick={(e) => this.setActive(3)}
              style={styles.tab[3]}
              value="3"
              className="customtab"
              icon={<FontIcon className="material-icons">filter_4</FontIcon>}
              label={<font>Approved</font>}>
              <div className="readmin-panel">

                {this.state.activeTab === 3 ?
                  <EVVApprovedClaims location={this.props.location.pathname.split('/')} handleClaimTabChange={this.handleClaimTabChange} />
                  : null}

              </div>
            </Tab>           
            
          </Tabs>
        </div>
      );
    }
}

export default ManageClaims;



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/EVVIndex.js